<template>
  <GmapMap
    ref="mapRef"
    :zoom="10"
    :center="{lat:10, lng:10}"
  >
    <GmapMarker
      :key="index"
      v-for="(m, index) in markers"
      :position="m.position"
      :icon="m.icon"
      :label="m.label"
      :zIndex="m.zIndex"
      :optimized="false"
    />

    <GmapPolyline
      v-if="decoded_suggest_path && decoded_suggest_path.length" :path="decoded_suggest_path"
      ref="polyline"
      :options ="polySuggestedOption"
    />

    <GmapPolyline
      v-if="decoded_travelled_path && decoded_travelled_path.length" :path="decoded_travelled_path"
      ref="polyline"
      :options ="polyTravelledOption"
    />
    
</GmapMap>
</template>

<script>
import { gmapApi } from 'gmap-vue';

export default {
  props: {
    markers: null,
    pathSuggested: null,
    pathTravelled: null,
    zoom: 9,
    polySuggestedOption: null,
    polyTravelledOption: null,
    options: null,

  },

  data() {
    return {
      decoded_suggest_path: [],
      decoded_travelled_path: [],
    }
  },

  watch: {
    markers: function (newMarkers) {
      this.$refs.mapRef.$mapPromise.then((map) => {
      let bounds = new google.maps.LatLngBounds();

        newMarkers.forEach((x) => {
          bounds.extend(x.position);          
        });

        if(this.decoded_travelled_path.length){
          this.decoded_travelled_path.forEach(element => bounds.extend(element));
        }

        if(this.decoded_suggest_path.length){
          this.decoded_suggest_path.forEach(element => bounds.extend(element));
        }

        map.fitBounds(bounds);
      })
    }
  },

  computed: {
    google: gmapApi,
  },

mounted () {
      this.$refs.mapRef.$mapPromise.then((map) => {
        let bounds = new google.maps.LatLngBounds();
        this.markers.forEach((x) => {
          bounds.extend(x.position);
        });
        if(this.pathTravelled !== null && this.pathTravelled.length !== 0 && this.pathTravelled[0] !== undefined && this.pathTravelled[0] !== null){
          this.decoded_travelled_path = google.maps.geometry.encoding.decodePath(this.pathTravelled[0])
          this.decoded_travelled_path.forEach(element => bounds.extend(element));
        }
        if(this.pathSuggested !== null && this.pathSuggested.length !== 0 && this.pathSuggested[0] !== undefined && this.pathSuggested[0] !== null){
          this.decoded_suggest_path = google.maps.geometry.encoding.decodePath(this.pathSuggested[0])
          this.decoded_suggest_path.forEach(element => bounds.extend(element));
        }
        
        map.fitBounds(bounds);
      })
    }
};
</script>



// WEBPACK FOOTER //
// src/components/job/batch/ManifestMap.vue